<style scoped>

#chart-wrapper {
    min-height: 300px;
}

</style>

<template>

<div id="chart-wrapper">

    <b-loading :active.sync="isLoading" :can-cancel="false" :is-full-page="false" />

    <div v-if="!isLoading" transition="fade">
        <div class="columns">
            <div class="column is-8">
                <b-message has-icon type="is-info" size="is-small">Look, just because I don't be givin' no man a foot massage don't make it right for Marsellus to throw Antwone into a glass motherfuckin' house, fuckin' up the way the nigger talks. </b-message>
            </div>
            <div class="column is-4">
                <find-category-dropdown title="Compare to another category" />
            </div>
        </div>
        <div id="chart" :class="category.id">
            <apex-chart type=bar :height="600" :options="chartOptions" :series="series" />
        </div>
    </div>
</div>

</template>

<script>

import VueApexCharts from 'vue-apexcharts'
import FindCategoryDropdown from "@/components/FindCategoryDropdown"


// [{
//     name: "Series 1",
//     data: [{
//         x: 'W1',
//         y: 22
//     ...]
// }, {
//     name: "Series 2",
//     data: [{
//    ...
// }]


export default {
    components: {
        "ApexChart": VueApexCharts,
        FindCategoryDropdown
    },
    props: ["category", "title", "sentiment"],
    data() {
        return {
            dataset: null,
            isLoading: true,
            series: [],
            chartOptions: {
                theme: {
                    palette: 'palette1' // upto palette10
                },

                title: {
                    text: this.title,
                    floating: true
                },
                dataLabels: {
                    enabled: false
                },
                //colors: ["#FF0000"],
                chart: {
                    stacked: true,
                    stackType: '100%'
                },
                plotOptions: {
                    bar: {
                        horizontal: true,
                    },
                    heatmap: {
                        shadeIntensity: 0.5,
                        // colorScale: {
                        //   ranges: [{
                        //       from: 0,
                        //       to: 5,
                        //       name: 'Low',
                        //       color: '#00A100'
                        //     },
                        //     {
                        //       from: 6,
                        //       to: 10,
                        //       name: 'Medium',
                        //       color: '#128FD9'
                        //     },
                        //     {
                        //       from: 11,
                        //       to: 20,
                        //       name: 'High',
                        //       color: '#FFB200'
                        //     },
                        //     {
                        //       from: 21,
                        //       to: 100,
                        //       name: 'Extreme',
                        //       color: '#FF0000'
                        //     }
                        //   ]
                        // }
                    }
                }
            }
        }
    },
    methods: {
        getCategoryTrends: function() {
            this.isLoading = true
            this.url = `${this.$root.api_base_url}categories/${this.category.id}/trends/`
            this.$http.get(this.url)
                .then(({
                    data
                }) => {
                    this.dataset = data
                })
                .catch((error) => {
                    this.$snackbar.open({
                        message: error,
                        type: "is-warning"
                    })
                    throw error
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
    },
    mounted: function() {
        this.getCategoryTrends()
    },
    watch: {
        dataset: function() {
            let sentiment = this.sentiment
                //let general = []
            let ux = []
            let price = []
            let support = []

            this.dataset.forEach(function(i) {
                let period = Object.keys(i)[0]
                let data = i[period]

                // Transform data for apex
                //general.push({x: period, y: data.paired[`${sentiment}.general`].percentage})
                let sum = data.paired[`${sentiment}.ux`].percentage + data.paired[`${sentiment}.price`].percentage + data.paired[`${sentiment}.support`].percentage

                ux.push({
                    x: period,
                    y: (data.paired[`${sentiment}.ux`].percentage / sum) * 100
                })

                price.push({
                    x: period,
                    y: (data.paired[`${sentiment}.price`].percentage / sum) * 100
                })

                support.push({
                    x: period,
                    y: (data.paired[`${sentiment}.support`].percentage / sum) * 100
                })

            })

            this.series.push({
                name: "Price",
                data: price
            })
            this.series.push({
                name: "Support",
                data: support
            })
            this.series.push({
                name: "User Experience",
                data: ux
            })

            //this.series.push({name:"General", data:general})
        },
    },
}

</script>
